import { VenueExistenceStatus } from '~types';

/**
 * Indicates that the user calling the API doesn't have permission to edit this venue
 * in other words, the venue exists, but the user doesn't have access.
 */
function isCannotEditVenue(venue: VenueExistenceStatus): boolean {
  return venue.isExisting && venue.venueId == null;
}

export { isCannotEditVenue };
